import * as React from 'react';
import {ReactElement} from 'react';
import {IElementStaticTableV2} from '../../../../../incase-domain/elements/staticTableV2';

interface ElementStaticTableV2Props {
    element: IElementStaticTableV2;
}

function ElementStaticTableV2(props: ElementStaticTableV2Props): ReactElement {
    const {element} = props;

    return (
        <div
            className="c-tableElementV2"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
                __html: element.text,
            }}
        />
    );
}

export default ElementStaticTableV2;
